// extracted by mini-css-extract-plugin
export default {"kitoButton":"styles_kitoButton__Wa5Og"};